// extracted by mini-css-extract-plugin
export var active = "_jn-2";
export var recordingDot = "_jn-1";
export var recordingIndicator = "_jn-0";